import React from 'react'
import styles from './OverseasMatchModal.module.scss'

const OverseasMatchModal = ({ isModalOpen, onReturn, onSubmit }) => {
	if (!isModalOpen) return null

	return (
		<div className={styles.modalOverlay}>
			<div className={styles.modalContainer}>
				<span className={styles.modalTitle}>해외 계약정보 입력하기</span>
				<span className={styles.modalDescription}>
					해외 대회에 출전할 예정이시군요. <br />
					지금 계약정보를 입력하시면, 매칭이 수월해져요!
				</span>

				<div className={styles.buttonContainer}>
					<button className={styles.cancelButton} onClick={onSubmit}>
						다음에
					</button>
					<button className={styles.confirmButton} onClick={onReturn}>
						해외 계약정보 입력
					</button>
				</div>
			</div>
		</div>
	)
}

export default OverseasMatchModal
